<div class="max-width-graph" #diurnalGraph></div>
